import { withIcon } from "../Icon"

export const IconUpload = withIcon(
  '<path stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m11.827 20.5-.004-9M19.938 17.158c1.614-1.155 2.307-3.243 1.71-5.158-.596-1.915-2.421-2.964-4.395-2.963h-1.14c-.746-2.956-3.205-5.14-6.185-5.488-2.98-.35-5.862 1.207-7.248 3.914a7.471 7.471 0 0 0 .998 8.289"/><path stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m14.95 13.818-3.127-3.182-3.126 3.182"/>',
)
